export default __webpack_public_path__ + "static/media/green-machine.c96fc76a.PNG";